(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[80365],{

/***/ 75020:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefoffice",
      function () {
        return __webpack_require__(88018);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ DebtReliefOfficeHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_debtreliefoffice_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85675);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _components_layouts_debtReliefOfficeWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1498);
/* harmony import */ var _components_shared_offersList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33124);
/* harmony import */ var _components_debtreliefoffice_whatIsDebtRelief__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25579);
/* harmony import */ var _components_debtreliefoffice_whatNext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5004);
/* harmony import */ var _components_debtreliefoffice_whySeekDebtRelief__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38446);
/* harmony import */ var _components_debtreliefoffice_debtFreeLife__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83466);










var __N_SSP = true;
function DebtReliefOfficeHome() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_debtReliefOfficeWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefoffice_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                style: {
                    padding: "0 15px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_offersList__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    offers: domain?.defaultOffers
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefoffice_whySeekDebtRelief__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefoffice_whatIsDebtRelief__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefoffice_whatNext__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefoffice_debtFreeLife__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,12672,1498,45951,49774,92888,40179], function() { return __webpack_exec__(75020); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);